import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams, ProductRecommendationModel } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { BusinessappsOrdersModel } from 'Pages/orders_design'
import { DEFAULT_REQUEST_PARAMS } from 'Constants/Global'
import { ProductModel } from 'Pages/orders'

export type ProductsState = {
	items: ResponseCatalog<ProductModel>
	params: RequestParams
	recommendations: ResponseCatalog<ProductRecommendationModel>
	businessapps: BusinessappsOrdersModel
}

export const productsInitialState: ProductsState = {
	items: new ResponseCatalog<ProductModel>(),
	recommendations: new ResponseCatalog<ProductRecommendationModel>(),
	params: new RequestParams(...DEFAULT_REQUEST_PARAMS),
	businessapps: new BusinessappsOrdersModel(),
}

export namespace productsNS {
	export type getAll = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type setAll = PayloadAction<ResponseCatalog<ProductModel>>
	export type setRequestParams = PayloadAction<RequestParams>

	export type getRecommendations = PayloadAction<string>

	export type setRecommendations = PayloadAction<ResponseCatalog<ProductRecommendationModel>>

	export type getBusinessapps = PayloadAction<string>

	export type setBusinessapps = PayloadAction<BusinessappsOrdersModel>
}

export const productsSlice = createSlice({
	name: 'orderProducts',
	initialState: productsInitialState,
	reducers: {
		getAll: (state, action: productsNS.getAll) => {},
		setAll: (state, action: productsNS.setAll) => {
			state.items = action.payload
		},
		setRequestParams: (state, action: productsNS.setRequestParams) => {
			state.params = action.payload
		},
		clearAll: (state) => {
			state.items = new ResponseCatalog<ProductModel>()
		},

		getRecommendations: (state, action: productsNS.getRecommendations) => {},
		setRecommendations: (state, action: productsNS.setRecommendations) => {
			state.recommendations = action.payload
		},

		clearRecommendations: (state) => {
			state.recommendations = new ResponseCatalog<ProductRecommendationModel>()
		},

		getBusinessapps: (state, action: productsNS.getBusinessapps) => {},
		setBusinessapps: (state, action: productsNS.setBusinessapps) => {
			state.businessapps = action.payload
		},

		clearBusinessapps: (state) => {
			state.businessapps = null
		},
	},
})
